const General = () => import('@/pages/system/setting/general.vue')

export default {
  path: 'general',
  meta: {
    label: 'general',
    auth: 'general'
  },
  component: {
    name: 'General',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemGeneralSetting',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: General
    }
  ]
}
